import { render, staticRenderFns } from "./DebateDetails.vue?vue&type=template&id=8f1e70e8&scoped=true&"
import script from "./DebateDetails.vue?vue&type=script&lang=js&"
export * from "./DebateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1e70e8",
  null
  
)

export default component.exports